module.exports = __webpack_public_path__ + "static/img/fawarehouse.5c4c8554.svg";